const defaultState = {
  isDrawerOpen: false,
  isVAS: false // VAS: van app shell
}

const TOGGLE_DRAWER = 'app/TOGGLE_DRAWER'
const SET_VAN_APP_SHELL = 'app/SET_VAN_APP_SHELL'

export default (state = defaultState, {type, ...actionProps}) => {
  switch (type) {
    case SET_VAN_APP_SHELL:
    case TOGGLE_DRAWER:
      return {
        ...state,
        ...actionProps
      }

    default:
      return state
  }
}

const toggleDrawerAction = isDrawerOpen => ({
  type: TOGGLE_DRAWER,
  isDrawerOpen: !isDrawerOpen
})

export const toggleDrawer = isDrawerOpen => dispatch =>
  dispatch(toggleDrawerAction(isDrawerOpen))

export const setVAS = value => dispatch => dispatch({type: SET_VAN_APP_SHELL, isVAS: value})



// WEBPACK FOOTER //
// ./src/app/app-reducer.js